/*
 *LossOfPay
 */
import React from "react";
import { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Row,
  Button,
  Input,
  Select,
  DatePicker,
  Table,
  Space,
  Modal,
  Tag,
  Badge,
} from "antd";

import { Typography } from "antd";
import { toast, ToastContainer } from "react-toastify";
import {
  FilterOutlined,
  ReloadOutlined,
  DownloadOutlined,
  EditOutlined,
  DeleteOutlined,
  SafetyOutlined,
  CloudUploadOutlined,
  CloseOutlined,
  SearchOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import "../Dashboard/index.css";
import SimpleReactValidator from "simple-react-validator";
import "../LeaveAndPermissions/LeaveDetails.css";
import "../EmployeeManagement/index.css";
import BreadcrumbComponent from "../../components/BreadCrumb";
import TextArea from "antd/es/input/TextArea";
import { useSelector, useDispatch } from "react-redux";
import api from "../../helpers";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import * as lopAction from "../../store/LeaveAndPermission/actions";
import { isEmpty } from "lodash";
import moment from "moment";
import dayjs from "dayjs";
//bread crumb
const BCrumb = [{ to: "/", title: "Home" }, { title: "LOP" }];

const LoseOfPayDetails = () => {
  const userType = localStorage.getItem("userType");
  const specificDispatch = useDispatch();
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    specificDispatch(
      lopAction.loadLOP({
        limit: 10,
        page: 1,
         status :"BOTH"
      })
    );
    specificDispatch(lopAction.loadSetting());
    specificDispatch(lopAction.loadLeaveDropdown());
  }, [specificDispatch]);

  //dropdown state from reducer
  const dropdownUpdate = useSelector((specificstate) => specificstate.Leave);
  const { dropDownList = {}, settingList = [], lopList = {} } = dropdownUpdate;
  const settingListOptions = !isEmpty(settingList)
    ? settingList.map((item) => {
      return {
        label: item.requestName,
        value: item._id,
        requestValue: item.requestValue,
      };
    })
    : [];
  const [searchLoading, setSearchLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  //validations
  const simpleValidator = React.useRef(new SimpleReactValidator());
  const simpleApproveValidator = React.useRef(new SimpleReactValidator());
  const [, forceUpdate] = React.useState();

  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  //filter initial data
  const [employeeData, setEmployeeData] = useState({
    employeeCode: "",
    designation: "",
    fromDate: "",
    toDate: "",
    reason: "",
  });
  //searchInput
  const [searchInput, setSearchInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(lopList?.total); // get this from your API response
  const [searchValue, setSearchValue] = useState({
    limit: 10,
    page: 1,
     status :"BOTH"
  });
  useEffect(() => {
    if (lopList) {
      setTotalCount(lopList?.total); // total is total count of records in the backend
    }
  }, [lopList]);
  //filter dropdown initial value
  const [filterEmployee, setFilterEmployee] = useState([]);
  const [filterEmployeeClear, setFilterEmployeeClear] = useState(false);
  const fuseOptions = {
    keys: ["employeeCode", "label"],
  };

  //modal dropdowns
  const [employeeCodeList, setEmployeeCodeList] = useState("");
  const [employeePayloadId, setEmployeePayloadId] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const [employeeCodeClear, setEmployeeCodeClear] = useState(false);
  const [department, setDepartment] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [fileNames, setFileNames] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  const [disabled, setDisabled] = useState(false);

  // const [selectedHours, setSelectedHours] = useState("");
  const [downloadLoader, setDownloadLoader] = useState(false);

  //filter date handler
  const handleDateChange = (name, value) => {
    setEmployeeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const [employeeDefaultSetting, setEmployeeDefaultSetting] = useState([]);
  //filter reset functionality
  const onReset = () => {
    setResetLoading(true);
    setFilterEmployeeClear(true);
    setTimeout(() => {
      setFilterEmployeeClear(false);
    }, 0);
    setTimeout(() => {
      setEmployeeData({
        employeeCode: "",
        fromDate: "",
        toDate: "",
      });
      setDepartment([]);
      setEmployeeDefaultSetting([]);

      setAbsentType([]);

      setResetLoading(false);
    }, 1000);
    dispatch(lopAction.loadLOP({ limit: 10, page: 1, status :"BOTH" }));
  };

  //Employee setting handler

  const [approvalModalOpen, setApprovalModalOpen] = useState(false);
  // sl cl options conditions
  const loginUser = JSON.parse(localStorage.getItem("user"));
  const loggedInEmployeeId = loginUser?.employeeId;

  const matchedEmployee = dropDownList?.employeeOptions?.find(
    (emp) => emp._id === loggedInEmployeeId
  );
  // modal clear data
  const clearModelData = () => {
    setLopModalData({
      employeeCode: "",
      lopDate: "",
      reason: "",
    });
    if (userType !== "admin") {
      const defaultLabel = `${matchedEmployee.label}`;
      setEmployeeCodeList(defaultLabel);
      setModalDepartment({
        label: matchedEmployee.departmentName || "",
        value: matchedEmployee.departmentId || "",
      });

      setModalDesignation({
        label: matchedEmployee.designationName || "",
        value: matchedEmployee.designationId || "",
      });
      setEmployeePayloadId(matchedEmployee._id);
    } else {
      setDepartment(null);
      setEmployeeCodeList();
    }
    // setEmployeeCodeList([]);
    // setEmployeeCodeClear(true);
    // setTimeout(() => {
    //   setEmployeeCodeClear(false);
    // }, 0);
    // setModalDepartment([]);
    // setModalDesignation([]);
    setAbsentType([]);
    setModalEmployeeDefaultSetting([]);
    setFileNames([]);
    setImagePreviews([]);
  };
  //modal data
  //lopDate
  const [lopModalData, setLopModalData] = useState({
    employeeCode: "",
    lopDate: "",
    reason: "",
  });

  //modal dropdown state
  const [modalDepartment, setModalDepartment] = useState([]);
  const [modalDesignation, setModalDesignation] = useState([]);
  const [absentType, setAbsentType] = useState([]);
  const [modalEmployeeDefaultSetting, setModalEmployeeDefaultSetting] =
    useState([]);

  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setLopModalData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //filter date handler
  const handleModalDateChange = (name, value) => {
    setLopModalData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleInitialSubmit = () => {
    if (simpleValidator.current.allValid()) {
      setIsConfirmVisible(true); // Show confirmation modal
    } else {
      simpleValidator.current.showMessages(); // Show validation errors
      forceUpdate(1);
    }
  };

  const handleSubmit = () => {
    setDisabled(true); // Disable the button temporarily
    setTimeout(() => setDisabled(false), 4000); // Re-enable after 4 seconds

    const payload = {
      EmployeeId: employeePayloadId,
      absentType: absentType.value,
      lopSettingId: modalEmployeeDefaultSetting.value,
      lopDate: lopModalData.lopDate.format("YYYY-MM-DD"),
      reason: lopModalData.reason,
      ...(!isEmpty(imagePreviews) && { attachment: imagePreviews[0].url }),
    };

    const endpoint = isEdit
      ? `/auth/employee/updatelop/${lopId}`
      : "/auth/employee/addlop";

    api
      .post(endpoint, payload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(lopAction.loadLOP(searchValue));
          toast.success(
            isEdit ? "Leave Details updated successfully" : "Leave Details added successfully"
          );
        } else {
          toast.warning(response?.data?.msg || "");
        }
        setIsModalVisible(false);
        setIsConfirmVisible(false);
      })
      .catch((err) => {
        setIsModalVisible(false);
        setIsConfirmVisible(false);
        const errorMsg =
          err?.response?.data?.message ||
          `An error occurred while ${isEdit ? "updating" : "adding"} the leave details`;
        toast.error(errorMsg, { containerId: "toast-1" });
      });

    setIsEdit(false);
  };

  // search
  const handleSearch = () => {
    const payload = {
      search: searchInput,
      page: currentPage,
      limit: pageSize,
       status :"BOTH"
    };
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);
    dispatch(lopAction.loadLOP(payload));
  };

  const handleEmployeeCodeClear = () => {
    clearModelData();

    setEmployeeCodeClear(true);
    setTimeout(() => {
      setEmployeeCodeClear(false);
    }, 0);
  };

  const handleEmployeeSelect = (selectedEmployee) => {
    // setEmployeeCodeList(selectedEmployee);
    setFilterEmployee(selectedEmployee);

    if (selectedEmployee.departmentName) {
      setModalDepartment({
        label: selectedEmployee.departmentName,
        value: selectedEmployee._id,
      });
    }

    if (selectedEmployee.designationName) {
      setModalDesignation({
        label: selectedEmployee.designationName,
        value: selectedEmployee._id,
      });
    }
  };

  //filter functionality

  const handleFilter = (e) => {
    e.preventDefault();
    setSearchLoading(true);

    setTimeout(() => {
      setSearchLoading(false);
    }, 500);

    let searchFilter = {};
    searchFilter.limit = pageSize;
    searchFilter.page = currentPage;
    searchFilter.status = "BOTH";
    if (employeeData.fromDate)
      searchFilter.lopDate = employeeData.fromDate.format("YYYY-MM-DD");
    if (employeeData.toDate)
      searchFilter.lopToDate = employeeData.toDate.format("YYYY-MM-DD");

    if (!isEmpty(department)) searchFilter.departmentId = department.value;
    if (!isEmpty(filterEmployee))
      searchFilter.employeeCode = filterEmployee?.value;
    if (!isEmpty(employeeDefaultSetting))
      searchFilter.lopSettingId = employeeDefaultSetting.value;

    setSearchValue(searchFilter);
    //dispatch

    if (!isEmpty(searchFilter)) {
      dispatch(lopAction.loadLOP(searchFilter));
    } else {
      dispatch(lopAction.loadLOP({ limit: 10, page: 1, status :"BOTH" }));
    }
  };
  //edit functionality
  const [lopId, setLopId] = useState();
  const handleEdit = (data) => {
    setShowDropdown(false);
    const employeeData = data.editData;
    setLopId(employeeData._id);

    setLopModalData({
      lopDate: employeeData.lopDate ? dayjs(employeeData.lopDate) : null,
      reason: employeeData.reason,
    });
    setModalDesignation({
      label: employeeData.designationName,
      value: employeeData.designationId,
    });
    setModalDepartment({
      label: employeeData.departmentName,
      value: employeeData.departmentId,
    });

    setAbsentType({
      label: employeeData.absentType,
      value: employeeData.absentType,
    });
    setModalEmployeeDefaultSetting({
      label: employeeData?.lopSettingId?.requestValue,
      value: employeeData?.lopSettingId._id,
    });
    if (employeeData.attachment) {
      setFileNames(employeeData.attachment);
      setImagePreviews([
        {
          url: employeeData.attachment,
          name: employeeData.attachment,
        },
      ]);
    } else {
      setImagePreviews([]);
    }
    const defaultLabel = `${employeeData.employeeCode} - ${employeeData.employeeName}`;
    setEmployeeCodeList(defaultLabel);
    setEmployeePayloadId(employeeData?.EmployeeId?._id);
    setIsEdit(true);
    setIsModalVisible(true);
  };

  //image handler
  //pofile picture on change and api functionality
  const handleSinglePhoto = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);
    setFileNames(fileArray[0].name);

    // Upload
    const uploadPromises = fileArray.map((file) => {
      const formData = new FormData();
      formData.append("profilePicture", file);
      return api
        .post("/auth/employee/upload-image", formData)
        .then((res) => {
          if (res?.status === 200 && res?.data?.file) {
            toast.success("Image uploaded successfully!", {
              containerId: "toast-1",
            });
            return {
              url: res.data.file,
              name: res.data.file,
            };
          } else {
            const errorMsg = res?.data?.error?.message || "Upload failed.";
            toast.error(errorMsg, { containerId: "toast-1" });
            return null;
          }
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.error?.message || "Upload error occurred.";
          toast.error(errorMsg, { containerId: "toast-1" });
          return null;
        });
    });

    const uploadedImages = await Promise.all(uploadPromises);
    const validUploads = uploadedImages.filter(Boolean);
    setImagePreviews(validUploads);
  };

  //image preview handler
  const handleRemoveImage = (urlToRemove) => {
    setImagePreviews([]);
    setFileNames("");
    URL.revokeObjectURL(urlToRemove);
  };

  //filter functionality

  //tableData
  const tableData = !isEmpty(lopList.data)
    ? lopList.data.map((data, index) => {
      return {
        sno: index + 1,
        employeeCode: data.employeeCode || "--",
        employeeName: data.EmployeeId?.employeeName || "--",
        lopDate: moment(data.lopDate).format("DD/MM/YYYY") || "--",
        lopType: data.absentType || "--",
        lopSettings: data?.lopSettingId?.requestValue || "--",
        lopHrs: data.lopHours || "--",
        reason: data.reason || "--",
        attachment: data.attachment,
        approvalStatus: data.lopStatus,
        status: data.status,
        editData: data,

        _id: data._id,
      };
    })
    : [];
  //table colums

  const columns = [
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          S.No
        </span>
      ),
      dataIndex: "sno",
      width: 70,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.sno - b.sno,
    },
    {
      title: <span className="poppins-txt">Action</span>,
      dataIndex: "action",
      width: 130,
      hidden: userType === "employee",
      render: (_, record) => (
        <Space style={{ gap: "17px" }}>
          {/* Edit Button */}
          <Button
            style={{
              background: "#34c38f",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            onClick={() => handleEdit(record)}
          >
            <EditOutlined style={{ color: "#fff", fontSize: 14 }} />
          </Button>

          {/* Delete Button */}
          <Button
            style={{
              background: "#f46a6a",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            onClick={() => {
              setDeleteModalOpen(true);
              setLopId(record._id);
            }}
          >
            <DeleteOutlined style={{ color: "#fff", fontSize: 14 }} />
          </Button>

          {/* Approve Button */}
          <Button
            style={{
              background: "#f1b44c",
              border: "none",
              minWidth: 30,
              height: 30,
              padding: "2px 4px",
              fontSize: "0.75rem",
            }}
            type="primary"
            onClick={() => {
              setApprovalModalStatus([]);
              setRemarks("");
              setApproveModalOpen(true);
              setLopId(record._id);
            }}
          >
            <SafetyOutlined style={{ color: "#fff", fontSize: 18 }} />
          </Button>
        </Space>
      ),
    },
    {
      title: "Employee Code",
      dataIndex: "employeeCode",
      hidden: userType === "employee",
      width: 160,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.employeeCode.localeCompare(b.employeeCode),
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      className: "poppins-txt-lg",
      hidden: userType === "employee",
      sorter: (a, b) => a.employeeName.localeCompare(b.employeeName),
    },
    {
      title: "LOP Date",
      dataIndex: "lopDate",
      className: "poppins-txt-lg",
      sorter: (a, b) => new Date(a.lopDate) - new Date(b.lopDate),
    },
    {
      title: "LOP Type",
      dataIndex: "lopType",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.lopType.localeCompare(b.lopType),
    },
    {
      title: "LOP Settings",
      dataIndex: "lopSettings",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.lopSettings.localeCompare(b.lopSettings),
    },
    {
      title: "LOP Hrs",
      dataIndex: "lopHrs",
      className: "poppins-txt-lg",
      sorter: (a, b) => {
        const getMinutes = (val) => {
          if (!val) return 0;
          const [h, m] = val
            .split(/[h\s]+/)
            .filter(Boolean)
            .map(Number);
          return h * 60 + (m || 0);
        };
        return getMinutes(a.lopHrs) - getMinutes(b.lopHrs);
      },
    },
    {
      title: "Reason",
      dataIndex: "reason",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.reason.localeCompare(b.reason),
    },
    {
  title: "Attachment",
  dataIndex: "attachment",
  className: "poppins-txt-lg",
  render: (text, record) => {
    // const hasAttachment = !!record.attachment;
    return record.attachment!==null && record.attachment  ? (
<a
        href={record.attachment}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "blue", textDecoration: "underline" }}
>
        View
</a>
    ) : (
<span style={{ color: "gray", textDecoration: "none", cursor: "not-allowed" }}>
        View
</span>
    );
  },
},
    {
      title: "Approval Status",
      dataIndex: "approvalStatus",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.approvalStatus.localeCompare(b.approvalStatus),
      render: (text, record) => {
        let color =
          text === "Pending"
            ? "#f46a6a"
            : text === "Approved"
              ? "#34c38f"
              : "#f46a6a";

        return (
          <div className="flex items-center justify-center">
            <div className="flex items-center w-full">
              <Badge
                count={text}
                style={{
                  backgroundColor: color,
                  color: "#fff",
                  padding: "0 8px",
                  height: "24px",
                  lineHeight: "24px",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </div>
            <div>
              <EyeOutlined
                style={{
                  fontSize: "16px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  color: "blue",
                }}
                onClick={() => {
                  setLopId(record._id);
                  setApprovalModalOpen(true);
                }}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Status
        </span>
      ),
      dataIndex: "status",
      width: 100,
      sorter: (a, b) => a.status - b.status,
      render: (status) => (
        <Tag
          style={{
            backgroundColor: status === 1 ? "#e6f4d7" : "#fae1e1",
            color: status === 1 ? "#34c38f" : "#f46a6a",
            fontWeight: 500,
            width: 60,
            height: 20,
            paddingTop: "2px",
            fontSize: "11px",
            textAlign: "center",
            lineHeight: "16px",
            borderRadius: 4,
            border: "none",
            fontFamily: "Poppins",
          }}
        >
          {status === 1 ? "Active" : "Inactive"}
        </Tag>
      ),
    },
  ];

  const columnApproval = [
    { title: "S.No", dataIndex: "sno", width: 70 },
    { title: "Approved By", dataIndex: "approvedBy" },
    { title: "Approved Date", dataIndex: "approvedDate" },
    { title: "Remarks", dataIndex: "remarks" },
  ];

  const selectedRecord =
    lopList?.data?.find((item) => item._id === lopId) || null;

  const tableApprovalData = selectedRecord
    ? [
      {
        _id: selectedRecord._id,
        sno: 1,
        approvedBy: selectedRecord.approvedByUserName || "--",
        approvedDate: selectedRecord.approvedOn
          ? moment(selectedRecord.approvedOn).format("DD/MM/YYYY")
          : "--",
        remarks: selectedRecord.remarks || "--",
      },
    ]
    : [];

  //download functionality

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = async () => {
    setDownloadLoader(true);
    let searchFilter = {};

    if (employeeData.fromDate)
      searchFilter.lopDate = employeeData.fromDate.format("YYYY-MM-DD");
    if (employeeData.toDate)
      searchFilter.lopToDate = employeeData.toDate.format("YYYY-MM-DD");

    if (!isEmpty(department)) searchFilter.departmentId = department;
    if (!isEmpty(filterEmployee))
      searchFilter.employeeCode = filterEmployee?.value;
    if (!isEmpty(employeeDefaultSetting))
      searchFilter.lopSettingId = employeeDefaultSetting;
    try {
      const res = await api.post("/auth/employee/getlop", searchFilter);
      const employees = res.data?.data || [];

      const mappedData = employees.map((data, index) => ({
        _id: data._id,
        sno: index + 1,
        employeeCode: data.employeeCode || "--",
        employeeName: data.employeeName || "--",
        lopDate: moment(data.lopDate).format("DD/MM/YYYY") || "--",
        lopType: data.absentType || "--",
        lopSettings: data?.lopSettingId?.requestValue || "--",
        lopHrs: data.lopHours || "--",
        reason: data.reason || "--",
        attachment: data.attachment || "",
        approvalStatus: data.lopStatus,
        status: data.status === 1 ? "Active" : "Inactive",
      }));

      // Only include fields for CSV that you want:
      const headers = [
        "S.No",
        "Employee Code",
        "Employee Name",
        "LOP Date",
        "LOP Type",
        "LOP Settings",
        "LOP Hrs",
        "Reason",
        "Attachment",
        "Approval Status",
        "Status",
      ];

      const csvRows = mappedData.map((item) => [
        item.sno,
        item.employeeCode,
        item.employeeName,
        item.lopDate,
        item.lopType,
        item.lopSettings,
        item.lopHrs,
        item.reason,
        item.attachment,
        item.approvalStatus,
        item.status,
      ]);

      const csvContent = [
        headers.join(","),
        ...csvRows.map((row) => row.join(",")),
      ].join("\n");

      downloadFile({
        data: csvContent,
        fileName: "lop.csv",
        fileType: "text/csv",
      });
    } catch (error) {
      if (error) {
        setDownloadLoader(false);
      }
    } finally {
      setDownloadLoader(false);
    }
  };
  // modal handling
  const showModalOpen = () => {
    setIsModalVisible(true);
    simpleValidator.current.hideMessages();
    forceUpdate(3);
    clearModelData();
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const absendOptions = [
    { Typography: "COC", value: "COC" },
    { Typography: "Late", value: "Late" },
    { Typography: "Others", value: "Others" },
    { Typography: "Leave", value: "Leave" },
    { Typography: "Permission", value: "Permission" },
  ];

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    setTimeout(() => { }, 1500);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // appove modal
  const [approvalModalStatus, setApprovalModalStatus] = useState([]);
  const approvalOptions = [
    { Typography: "Approved", value: "Approved" },
    { Typography: "Rejected", value: "Rejected" },
  ];
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [remarks, setRemarks] = useState("");
  const handleApprovalChange = (e) => {
    const { name, value } = e.target;
    if (name === "remarks") {
      setRemarks(value);
    }
  };
  const handleApproveModalCancel = () => {
    setApproveModalOpen(false);
  };
  //update approval
  const handleApproveUpdate = () => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);
    if (simpleApproveValidator.current.allValid()) {
      const payload = {
        lopStatus: approvalModalStatus.value,
        remarks: remarks,
      }; //
      api
        .post(`/auth/employee/lopapproval/${lopId}`, payload)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            dispatch(lopAction.loadLOP(searchValue));
            // dispatch(leaveAction.loadLeaveDetails(searchValue));
            toast.success("LOP approved successfully");
          } else {
            toast.warning(response?.data?.msg || "");
          }
          setApproveModalOpen(false);
          return response.data;
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.message ||
            "An error occurred while approving the lop details";
          toast.error(errorMsg);
          return Promise.reject(err);
        });
    } else {
      simpleApproveValidator.current.showMessages(); // SHOW all error messages
      forceUpdate(1);
    }
  };
  //delete
  // delete modal
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const handleDeleteModalCancel = () => {
    setDeleteModalOpen(false);
  };
  const handleDelete = () => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);
    const payload = {
      lopId: [lopId],
      status:3
    };
    api
      .post(`/auth/employee/deletelop`, payload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(lopAction.loadLOP(searchValue));
          // dispatch(leaveAction.loadLeaveDetails(searchValue));
          toast.success("LOP deleted successfully");
        } else {
          toast.warning(response?.data?.msg || "");
        }
        setDeleteModalOpen(false);
        return response.data;
      })
      .catch((err) => {
        setDeleteModalOpen(false);
        const errorMsg =
       err?.response?.data?.error||err?.response?.data?.message ||
          "An error occurred while deleting the lop";
        toast.error(errorMsg);
        return Promise.reject(err);
      });
  };
  return (
    <React.Fragment>
      <div className="pl-5">
        <MetaTags>
          <title>LOP | Mequals</title>
        </MetaTags>
      </div>

      <Row justify="space-between" className="mr-4">
        <Col>
          <BreadcrumbComponent title="LOP" items={BCrumb} />
        </Col>

        <Col>
          <Button
            className="custom-btn mt-2"
            type="primary"
            size="medium"
            onClick={() => showModalOpen()}
          >
            {/* <span>{isEdit ? "Edit Leave" : "Apply Leave"}</span> */}
            Apply LOP
          </Button>
        </Col>
      </Row>
      <Modal
        open={isModalVisible}
        onCancel={handleModalClose}
        title="Apply LOP"
        className="poppins-txt custom-active-modal"
        centered
        maskClosable={false}
        footer={null}
        width="70vw"
        maxWidth="1200px"
        style={{
          padding: 0,
          marginLeft: windowDimensions.width > 992 ? "220px" : "0",
        }}
      >
        <div className="custom-modal-content">
          <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Employee Code
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>

              <ReactSearchAutocomplete
                name="employeeCodeList"
                inputSearchString={employeeCodeList}
                key={employeeCodeClear}
                items={
                  showDropdown && dropDownList.employeeOptions
                    ? dropDownList.employeeOptions
                    : []
                }
                value={employeeCodeList}
                type="autoComplete"
                resultStringKeyName="label"
                showIcon={false}
                onChange={(e) => {
                  if (userType !== "employee")
                    setEmployeeCodeList(e.target.value);
                }}
                onFocus={() => {
                  if (userType !== "employee") setShowDropdown(true);
                }}
                onSelect={(item) => {
                  if (userType !== "employee") {
                    setEmployeeCodeList(item.label);
                    setEmployeePayloadId(item._id);
                    setShowDropdown(false);
                    handleEmployeeSelect(item);
                  }
                }}
                onSearch={(string, results) => {
                  if (userType !== "employee") setShowDropdown(true);
                }}
                onClear={() => {
                  if (userType !== "employee") handleEmployeeCodeClear();
                }}
                showClear={userType !== "employee"}
                placeholder="Enter Employee code"
                fuseOptions={fuseOptions}
                className="text-end hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mb-[-6px]"
                styling={{
                  height: "30px",
                  border: "1px solid #ced4da",
                  borderRadius: "4px",
                  backgroundColor:
                    userType === "employee" ? "#f5f5f5" : "white",
                  pointerEvents: userType === "employee" ? "none" : "auto",
                  opacity: userType === "employee" ? 0.6 : 1,
                  boxShadow: "none",
                  textAlign: "end",
                  hoverBackgroundColor: "lightgray",
                  color: "black",
                  fontSize: "12px",
                  fontFamily: "Poppins",
                  iconColor: "green",
                  clearIconMargin: "3px 8px 0 0",
                  zIndex: 10,
                }}
              />

              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "employeeCode",
                  employeeCodeList,
                  "required"
                )}
              </span>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Department
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>
              <Select
                placeholder="Select department"
                allowClear
                className="custom-select"
                name="modalDepartment"
                value={modalDepartment}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setModalDepartment({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setModalDepartment({ label: "", value: "" });
                  }
                }}
                disabled
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "modalDepartment",
                  modalDepartment,
                  "required"
                )}
              </span>
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Designation
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>
              <Select
                placeholder="Select designation"
                allowClear
                className="custom-select"
                name="modalDesignation"
                value={modalDesignation}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setModalDesignation({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setModalDesignation({ label: "", value: "" });
                  }
                }}
                disabled
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "modalDesignation",
                  modalDesignation,
                  "required"
                )}
              </span>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{ marginTop: "10px" }}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Absent Type
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>
              <Select
                placeholder="Select absent type"
                allowClear
                className="custom-select"
                name="absentType"
                value={absentType}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setAbsentType({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setAbsentType({ label: "", value: "" });
                  }
                }}
                options={absendOptions}
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "absentType",
                  absentType,
                  "required"
                )}
              </span>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Employee Default Setting{" "}
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>
              <Select
                placeholder="Select employee default setting"
                allowClear
                className="custom-select"
                name="modalEmployeeDefaultSetting"
                value={modalEmployeeDefaultSetting}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setModalEmployeeDefaultSetting({
                      label: options.label,
                      value: value,
                      requestValue: options.requestValue,
                    });
                  } else {
                    // cleared selection
                    setModalEmployeeDefaultSetting({
                      label: "",
                      value: "",
                      requestValue: "",
                    });
                  }
                }}
                options={settingListOptions}
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
                autoComplete="off"
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleValidator.current.message(
                  "employeeDefaultSetting",
                  modalEmployeeDefaultSetting,
                  "required"
                )}
              </span>
              {modalEmployeeDefaultSetting.requestValue && (
                <Typography
                  style={{
                    marginTop: "5px",
                    color: "#ef3022",
                    fontSize: "12px",
                    fontFamily: "poppins",
                    textAlign: "right", // Align text to the right
                    float: "right", // Float to the right
                  }}
                >
                  {modalEmployeeDefaultSetting.requestValue}
                </Typography>
              )}
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <div>
                <div className="mb-2">
                  <Typography className="poppins-txt">
                    LOP Date{" "}
                    <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                  </Typography>
                </div>
                <DatePicker
                  className="custom-select py-2"
                  name="lopDate"
                  value={lopModalData.lopDate}
                  onChange={(date) => handleModalDateChange("lopDate", date)}
                />
                <span
                  style={{
                    color: "#ef3022",
                    fontSize: "11px",
                    marginTop: "8px",
                    fontFamily: "poppins",
                    display: "block",
                  }}
                >
                  {simpleValidator.current.message(
                    "lopDate",
                    lopModalData.lopDate,
                    "required"
                  )}
                </span>
              </div>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <div className="mb-2">
                <Typography className="poppins-txt">Reason</Typography>
              </div>
              <TextArea
                placeholder="Enter Reason"
                rows={3}
                name="reason"
                value={lopModalData.reason}
                onChange={(e) => handleModalChange(e)}
              />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <Typography className="poppins-txt">Attachment File</Typography>
              <div style={{ position: "relative", marginTop: 8 }}>
                <Input
                  value={fileNames}
                  accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain"
                  placeholder="Choose File"
                  readOnly
                  // Clicking the input triggers the hidden file input click
                  onClick={() =>
                    document.getElementById("gallery-file-upload").click()
                  }
                  // Prefix with a filled cloud upload icon, styled larger with margin (gap)
                  prefix={
                    <CloudUploadOutlined
                      style={{
                        color: "blue",
                        fontSize: 24,
                        marginRight: 12, // Increase the gap between icon and placeholder
                      }}
                    />
                  }
                  style={{
                    cursor: "pointer",
                    paddingLeft: 8, // Adds a little more padding on the left for the text
                  }}
                />

                {/* Hidden file input overlay */}
                <input
                  id="gallery-file-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleSinglePhoto} // <- change handler name too
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                  }}
                />
              </div>

              {/* Image previews */}
              {imagePreviews.length > 0 && (
                <div style={{ marginTop: 16 }}>
                  {imagePreviews.map((img, imgsIndex) => (
                    <div
                      key={imgsIndex}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Typography
                        style={{
                          textDecoration: "underline",
                          color: "blue",
                          "&:hover": { color: "darkblue" },
                          fontSize: "14px",
                        }}
                        onClick={() => window.open(img.url, "_blank")}
                      >
                        View
                      </Typography>

                      <CloseOutlined
                        onClick={() => handleRemoveImage(imgsIndex)}
                        style={{
                          fontSize: 16,
                          color: "#ef3022",
                          padding: "2px",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </Col>
          </Row>
        </div>

        {/* Custom footer with cancel and confirm buttons */}
        <div
          className="custom-modal-footer"
          style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="custom-btn"
            onClick={handleModalClose}
            style={{
              backgroundColor: "#f46a6a",
              color: "#fff",
              border: "none",
              marginRight: "10px",
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={disabled}
            className="custom-btn"
            style={{
              backgroundColor: "#34c38f",
              color: "#fff",
              border: "none",
            }}
            onClick={handleInitialSubmit}
          >
            {isEdit ? "Update" : "Submit"}
          </Button>
        </div>
        <ToastContainer
          containerId="toast-1"
          position="top-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          style={{
            fontSize: "12px",
          }}
          pauseOnHover
          theme="dark"
        />
      </Modal>
      <Modal
        open={isConfirmVisible}
        onCancel={() => setIsConfirmVisible(false)}
        title={"Confirmation"}
        // title="Apply Leave"
        className="poppins-txt custom-active-modal"
        centered
        maskClosable={false}
        width={450}
        footer={null}
        maxWidth="1200px"
        style={{
          padding: 0,
          marginLeft: windowDimensions.width > 992 ? "220px" : "0",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <p className="poppins-txt" style={{ padding: "15px" }}>
            Are you sure Do you want to {isEdit ? "update" : "submit"} this
            request?
          </p>

          <div
            className="custom-modal-footer"
            style={{
              borderTop: "1px solid #ccc",
              padding: "10px 16px 0px 0px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="custom-btn"
              style={{
                backgroundColor: "#f46a6a",
                color: "#fff",
                border: "none",
                marginRight: "10px",
              }}
              onClick={() => setIsConfirmVisible(false)}
            >
              Close
            </Button>
            <Button
              disabled={disabled}
              className="custom-btn"
              onClick={() => {
                handleSubmit();
                setIsConfirmVisible(false);
              }}
              style={{
                backgroundColor: "#34c38f",
                color: "#fff",
                border: "none",
              }}
            >
              Confirm
            </Button>
          </div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          ></div>
        </div>
      </Modal>
      <Modal
        title={"Confirmation"}
        open={deleteModalOpen}
        onCancel={handleDeleteModalCancel}
        cancelText="Cancel"
        className="poppins-txt custom-active-modal"
        width={450}
        footer={null}
        // style={{ padding: 0 }}
        centered
      >
        <div className="custom-modal-content">
          <p>Are you sure you want to delete this lop?</p>
        </div>

        <div
          className="custom-modal-footer"
          style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="custom-btn"
            style={{
              backgroundColor: "#f46a6a",
              color: "#fff",
              border: "none",
              marginRight: "10px",
            }}
            onClick={() => handleDeleteModalCancel()}
          >
            Close
          </Button>
          <Button
            disabled={disabled}
            className="custom-btn"
            onClick={() => handleDelete()}
            style={{
              backgroundColor: "#34c38f",
              color: "#fff",
              border: "none",
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>

      <div
        style={{
          background: "#ffffff",
          margin: "4px 8px 4px 8px", // top, right, bottom, left
          padding: "16px",
          borderRadius: "8px 8px 0px 0px",
        }}
      >
        <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">Employee Code</Typography>
            </div>
            <ReactSearchAutocomplete
              name="filterEmployee"
              key={filterEmployeeClear}
              items={
                dropDownList.employeeOptions ? dropDownList.employeeOptions : []
              }
              value={filterEmployee}
              type="autoComplete"
              resultStringKeyName="label"
              showIcon={false}
              onChange={(e) => {
                setFilterEmployee(e.target.value);
              }}
              onSelect={(item) => {
                setFilterEmployee(item);
              }}
              //   onSelect={handleEmployeeSelect}
              onClear={() => setFilterEmployee([])}
              showClear
              placeholder="Enter Employee code"
              fuseOptions={fuseOptions} // Search on both fields
              className="text-end hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mb-[-6px]"
              styling={{
                height: "30px",
                border: "1px solid #ced4da",
                borderRadius: "4px",
                backgroundColor: "white",
                boxShadow: "none",
                textAlign: "end",
                hoverBackgroundColor: "lightgray",
                color: "black",
                // marginBottom: "-3px",
                fontSize: "12px",
                fontFamily: "Poppins",
                iconColor: "green",
                clearIconMargin: "3px 8px 0 0",
                zIndex: 10,
              }}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">Department</Typography>
            </div>
            <Select
              placeholder="Select department"
              allowClear
              className="custom-select"
              name="department"
              value={department}
              onChange={(value, options) => {
                if (options) {
                  // normal selection
                  setDepartment({
                    label: options.label,
                    value: value,
                  });
                } else {
                  // cleared selection
                  setDepartment({ label: "", value: "" });
                }
              }}
              options={dropDownList.departmentOptions || []}
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
              autoComplete="off"
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div>
              <div className="mb-2">
                <Typography className="poppins-txt">Leave From Date</Typography>
              </div>
              <DatePicker
                className="custom-select py-2"
                name="fromDate"
                value={employeeData.fromDate}
                onChange={(date) => handleDateChange("fromDate", date)}
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div>
              <div className="mb-2">
                <Typography className="poppins-txt">Leave To Date</Typography>
              </div>
              <DatePicker
                className="custom-select py-2"
                name="toDate"
                value={employeeData.toDate}
                onChange={(date) => handleDateChange("toDate", date)}
              />
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={6}>
            <div className="mb-2">
              <Typography className="poppins-txt">
                Employee default Setting
              </Typography>
            </div>
            <Select
              placeholder="Select employee default setting"
              allowClear
              className="custom-select"
              name="employeeDefaultSetting"
              value={employeeDefaultSetting}
              onChange={(value, options) => {
                if (options) {
                  // normal selection
                  setEmployeeDefaultSetting({
                    label: options.label,
                    value: value,
                  });
                } else {
                  // cleared selection
                  setEmployeeDefaultSetting({ label: "", value: "" });
                }
              }}
              options={settingListOptions}
              dropdownRender={(menu) => (
                <h1 className="option-text-font">{menu}</h1>
              )}
              autoComplete="off"
            />
          </Col>
        </Row>

        <Row justify="end" style={{ marginTop: "8px" }}>
          <Col>
            <Button
              className="custom-btn"
              icon={<ReloadOutlined style={{ fontSize: "16px" }} />}
              size="middle"
              onClick={onReset}
              loading={resetLoading}
              danger
              style={{ marginRight: "12px" }}
            >
              Reset
            </Button>
            <Button
              className="custom-btn"
              type="primary"
              size="middle"
              icon={<FilterOutlined style={{ fontSize: "18px" }} />}
              htmlType="submit"
              onClick={handleFilter}
              loading={searchLoading}
            >
              Apply Filter
            </Button>
          </Col>
        </Row>
      </div>

      <div
        style={{
          background: "#ffffff",
          margin: "20px 8px 15px 8px", // top, right, bottom, left
          padding: "16px",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col>
            <Input
              placeholder="Search..."
              allowClear
              style={{ width: 250, fontFamily: "Poppins" }}
              name="searchInput"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              type="text"
              autoComplete="off"
            />

            <Button
              icon={<SearchOutlined />}
              type="primary"
              style={{ marginLeft: 8 }}
              onClick={handleSearch}
            />
          </Col>
          <Col>
            <Button
              className="custom-btn"
              size="medium"
              type="primary"
              icon={<DownloadOutlined />}
              loading={downloadLoader}
              onClick={exportToCsv}
            >
              Download
            </Button>
          </Col>
        </Row>

        <Table
          columns={columns}
          loading={searchLoading}
          dataSource={tableData}
          className="poppins-txt"
          rowKey={(record) => record._id}
          rowClassName={"text-[12px]"}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalCount, // make sure you provide total count from API
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "30"],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          }}
          sortDirections={["ascend", "descend"]}
          showSorterTooltip={"sorter-icon"}
          scroll={{
            x: 765,
          }}
          onChange={(pagination, filters, sorter) => {
            const { current, pageSize } = pagination;
            setCurrentPage(current); // you can manage currentPage and pageSize in your component state if needed
            setPageSize(pageSize);
            const updatedParams = {
              ...searchValue,
              page: current,
              limit: pageSize,
               status :"BOTH"
            };

            setSearchValue(updatedParams);
            specificDispatch(lopAction.loadLOP(updatedParams));
          }}
        />
        <Modal
          title={"Confirmation"}
          open={approveModalOpen}
          onCancel={handleApproveModalCancel}
          cancelText="Cancel"
          className="poppins-txt custom-active-modal"
          width={450}
          footer={null}
          // style={{ padding: 0 }}
          centered
        >
          <div className="custom-modal-content">
            {/* <p>Are you sure you want to approve this leave details?</p> */}
            <Col xs={24}>
              <div className="mb-2">
                <Typography className="poppins-txt">
                  Approval Status
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </Typography>
              </div>
              <Select
                placeholder="Select approval status"
                allowClear
                className="custom-select"
                name="approvalModalStatus"
                value={approvalModalStatus}
                onChange={(value, options) => {
                  if (options) {
                    // normal selection
                    setApprovalModalStatus({
                      label: options.label,
                      value: value,
                    });
                  } else {
                    // cleared selection
                    setApprovalModalStatus({ label: "", value: "" });
                  }
                }}
                options={approvalOptions}
                autoComplete="off"
                dropdownRender={(menu) => (
                  <h1 className="option-text-font">{menu}</h1>
                )}
              />
              <span
                style={{
                  color: "#ef3022",
                  fontSize: "11px",
                  marginTop: "8px",
                  fontFamily: "poppins",
                  display: "block",
                }}
              >
                {simpleApproveValidator.current.message(
                  "approvalModalStatus",
                  approvalModalStatus,
                  "required"
                )}
              </span>
            </Col>
            <Col xs={24} style={{ marginTop: "5px" }}>
              <div className="mb-2">
                <Typography className="poppins-txt">Remarks</Typography>
              </div>
              <TextArea
                placeholder="Enter Remarks"
                rows={3}
                name="remarks"
                value={remarks}
                onChange={(e) => handleApprovalChange(e)}
              />
            </Col>
          </div>

          <div
            className="custom-modal-footer"
            style={{
              borderTop: "1px solid #ccc",
              padding: "10px 16px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="custom-btn"
              style={{
                backgroundColor: "#f46a6a",
                color: "#fff",
                border: "none",
                marginRight: "10px",
              }}
              onClick={() => handleApproveModalCancel()}
            >
              Close
            </Button>
            <Button
              disabled={disabled}
              className="custom-btn"
              onClick={() => handleApproveUpdate()}
              style={{
                backgroundColor: "#34c38f",
                color: "#fff",
                border: "none",
              }}
            >
              Confirm
            </Button>
          </div>
        </Modal>
        <Modal
          title={"Approval Status"}
          open={approvalModalOpen}
          onCancel={() => setApprovalModalOpen(false)}
          cancelText="Cancel"
          className="poppins-txt custom-active-modal"
          footer={null}
          maskClosable={false}
          // style={{ top: 90, left: 100 }}
          width={
            windowDimensions.width > 992
              ? 700
              : windowDimensions.width > 600
                ? 600
                : windowDimensions.width - 40
          }
          style={{
            top: 90,
            padding: 0,
            ...(windowDimensions.width > 1189
              ? { marginLeft: "400px" }
              : windowDimensions.width > 992
                ? { marginLeft: "300px" }
                : windowDimensions.width > 600
                  ? { margin: "0 auto" }
                  : windowDimensions.width > 40
                    ? { margin: "0 auto" }
                    : { marginLeft: "0" }),
          }}
        // style={{ padding: 0 }}
        >
          <div className="custom-modal-content">
            <Table
              columns={columnApproval}
              dataSource={tableApprovalData}
              className="poppins-txt mb-2"
              rowKey={(record) => record._id}
              rowClassName={"text-[12px]"}
              size="small"
              pagination={false}
            />
          </div>

          <div
            className="custom-modal-footer"
            style={{
              borderTop: "1px solid #ccc",
              padding: "10px 16px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="custom-btn"
              style={{
                backgroundColor: "#f46a6a",
                color: "#fff",
                border: "none",
                marginRight: "10px",
              }}
              onClick={() => setApprovalModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </Modal>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};
//LoseOfPayDetails
export default LoseOfPayDetails;
